import { render } from "./RatingComponent.vue?vue&type=template&id=09bf6f57"
import script from "./RatingComponent.vue?vue&type=script&lang=js"
export * from "./RatingComponent.vue?vue&type=script&lang=js"

import "./RatingComponent.vue?vue&type=style&index=0&id=09bf6f57&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__